import React, { useContext, useEffect } from 'react'
import 'stylesheets/TimerAppStyles/CreateTodoButton.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { TodoContext } from 'contexts/TimerAppContexts/TodoContext'

const CreateTodoButton = () => {
    const { setOpenModal, openModal } = useContext(TodoContext);
    const modal = document.querySelector("#modal");
    const body = document.querySelector("body")
    const root = document.getElementById("root")
    useEffect(() => {
        if (openModal === true) {
            if (window.innerHeight < 624) {
                root.style.display = "none"
            }
            modal.style.display = "flex";
            body.style.overflow = "hidden";
        } else {
            root.style.display = "block"
            body.style.overflowY = "auto";
            modal.style.display = "none";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal, body.style])

    const handdleOpenModal = () => {
        if (window.innerHeight > 624) {
            let distanciaTop = window.scrollY;
            const modalForm = document.getElementById("modal")
            modalForm.style.top = distanciaTop + "px"
            setOpenModal(!openModal)
        } else{
            setOpenModal(!openModal)
        }
    }
    return (
        <button className='newtodo-btn' onClick={handdleOpenModal}>
            <FontAwesomeIcon icon={faPlus} className='add-icon' />
        </button>
    )
}

export { CreateTodoButton }